import { Component, OnInit } from '@angular/core';

import 'flowbite';
import { initFlowbite } from 'flowbite';

import { I18nService } from './i18n/i18n.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'RAWI';

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    initFlowbite();
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);
  }
}
